import React, { useEffect, useState } from "react";
import { Cookie, X } from "lucide-react";
import { Link } from "react-router-dom";
import { useLang } from "@/context/LangContext";

const STORAGE_KEY = "tigik_cookies_acknowledged_v1";

const T = {
  sk: {
    text: "Tigik používa iba nevyhnutné cookies / local storage pre funkčnosť (prihlásenie, jazyk, preferencie). Nezbierame žiadne tracking ani reklamné dáta.",
    privacy: "Viac v Zásadách súkromia",
    ok: "Rozumiem",
  },
  en: {
    text: "Tigik uses only essential cookies / local storage for functionality (login, language, preferences). We collect no tracking or advertising data.",
    privacy: "More in Privacy Policy",
    ok: "Got it",
  },
  cs: {
    text: "Tigik používá pouze nezbytné cookies / local storage pro funkčnost (přihlášení, jazyk, preference). Nesbíráme žádná tracking ani reklamní data.",
    privacy: "Více v Zásadách soukromí",
    ok: "Rozumím",
  },
  de: {
    text: "Tigik verwendet nur essenzielle Cookies / Local Storage für die Funktionalität (Login, Sprache, Einstellungen). Wir erfassen keine Tracking- oder Werbedaten.",
    privacy: "Mehr in der Datenschutzerklärung",
    ok: "Verstanden",
  },
  pl: {
    text: "Tigik używa wyłącznie niezbędnych cookies / local storage do funkcjonalności (logowanie, język, preferencje). Nie zbieramy żadnych danych śledzących ani reklamowych.",
    privacy: "Więcej w Polityce prywatności",
    ok: "Rozumiem",
  },
  fr: {
    text: "Tigik utilise uniquement les cookies / local storage nécessaires au fonctionnement (connexion, langue, préférences). Nous ne collectons aucune donnée de tracking ni publicitaire.",
    privacy: "Plus d'infos dans la Politique de confidentialité",
    ok: "Compris",
},
};

export default function CookiesBanner() {
  const { lang } = useLang() || { lang: "sk" };
  const t = T[lang] || T.sk;
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (!localStorage.getItem(STORAGE_KEY)) {
      // Slight delay so it doesn't compete with initial page render
      const id = setTimeout(() => setShow(true), 800);
      return () => clearTimeout(id);
    }
  }, []);

  const ack = () => {
    try { localStorage.setItem(STORAGE_KEY, new Date().toISOString()); } catch (_) {}
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      data-testid="cookies-banner"
      className="fixed bottom-2 left-2 right-2 md:bottom-4 md:left-4 md:right-auto md:max-w-md z-50 bg-zinc-950 border border-gold-700/40 shadow-2xl"
      style={{ boxShadow: "0 12px 40px rgba(0,0,0,0.6), 0 0 24px rgba(212,175,55,0.08)" }}
    >
      <div className="p-4 flex items-start gap-3">
        <Cookie className="w-5 h-5 text-gold-400 flex-shrink-0 mt-0.5" />
        <div className="flex-1 text-xs text-zinc-300 leading-relaxed">
          {t.text}{" "}
          <Link to="/privacy" className="text-gold-400 hover:text-gold-300 underline decoration-dotted" data-testid="cookies-privacy-link">
            {t.privacy}
          </Link>
          <div className="mt-3 flex justify-end">
            <button
              data-testid="cookies-ack-btn"
              onClick={ack}
              className="wb-btn-primary px-4 py-1.5 text-[11px] font-mono uppercase tracking-wider"
            >
              {t.ok}
            </button>
          </div>
        </div>
        <button
          onClick={ack}
          aria-label="Close"
          data-testid="cookies-close-btn"
          className="text-zinc-600 hover:text-zinc-300 transition-colors -mt-1 -mr-1"
        >
          <X className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
}
